module.exports = __webpack_public_path__ + "img/gift-card.6e821510.svg";